import React, { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      data-testid="scroll-to-top-btn"
      aria-label={t("scrollTop")}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-20 sm:bottom-24 right-6 z-[60] h-12 w-12 rounded-full bg-[#C05A3A] hover:bg-[#A54C30] text-[#F9F6F0] shadow-lg shadow-[#C05A3A]/30 flex items-center justify-center transition-all hover:-translate-y-0.5"
    >
      <ArrowUp className="h-5 w-5" strokeWidth={1.5} />
    </button>
  );
}
